<script setup lang="ts">
import { AppText } from '@shared/ui/typography'

defineOptions({
  name: 'DisciplineScheduleSelector',
})

withDefaults(defineProps<{
  text: string
  selected?: boolean
  disabled?: boolean
  /** Striped: outside the tutor's working hours. */
  unavailable?: boolean
}>(), {
  selected: false,
  disabled: false,
  unavailable: false,
})

const emit = defineEmits<{
  click: []
}>()
</script>

<template>
  <button
    type="button"
    :class="['discipline-schedule-selector', { selected, disabled, unavailable }]"
    :disabled="disabled"
    @click="emit('click')"
  >
    <AppText
      name="body1"
      class="discipline-schedule-selector__text"
    >
      {{ text }}
    </AppText>
    <slot />
  </button>
</template>

<style scoped lang="scss" src="./DisciplineScheduleSelector.scss" />
